export const CREATE_FORMS = "Create_form_json";
export const UPDATE_PROPERTIES = "UPDATE_PROPERTIES";
export const ADD_FORMS = "ADD_FORMS";
export const UNDO = "UNDO";
export const REDO = "REDO";
export const INITIALIZE_ACTION_STACK = "INITIALIZE_ACTION_STACK";
export const PUSH_ACTION_STACK = "PUSH_ACTION_STACK";
export const ADD_THEME_INFO = "ADD_THEME_INFO";
export const AUTO_COMPLETE_VARIABLES = "AUTO_COMPLETE_VARIABLES";
export const SAVE_ORIGINAL_FORM_DATA = "SAVE_ORIGINAL_FORM_DATA"
export const SET_SELECTED_FORM_DATA = "SET_SELECTED_FORM_DATA"
export const REMOVE_FORM = 'REMOVE_FORM';
export const UPDATE_FORM_WIDGET_PROPERTIES = 'UPDATE_FORM_WIDGET_PROPERTIES';

export interface ActionStack {
  actionStack: any[];
  actionPointer: number;
  autoCompleteVariables: any[];
  formData: {};
  selectedForm:{};
}

export interface DataCreateForms {
  formId: string;
  data: any;
}

export interface UpdatePropertiesForm {
  formid?: string;
  data?: any;
  id?: string;
  autoMerge?: boolean;
}

export interface DragDelete {
  formid?: string;
  itemId?: any;
  draggedItemContainer?: any;
}

export interface DragAdd {
  formid?: string;
  draggedItem?: any;
  droppedContainer?: any;
}

export interface DragDropData {
  formid?: string;
  draggedItem?: any;
  droppedContainer?: any;
  draggedItemContainer?: any;
}

export interface ThemeInfo {
  formId: string;
  theme: any;
}

interface FormCreationAction {
  type:
    | typeof CREATE_FORMS
    | typeof UPDATE_PROPERTIES
    | typeof ADD_FORMS
    | typeof UNDO
    | typeof REDO
    | typeof INITIALIZE_ACTION_STACK
    | typeof PUSH_ACTION_STACK
    | typeof ADD_THEME_INFO
    | typeof AUTO_COMPLETE_VARIABLES
    | typeof SAVE_ORIGINAL_FORM_DATA
    | typeof SET_SELECTED_FORM_DATA
    | typeof REMOVE_FORM
    | typeof UPDATE_FORM_WIDGET_PROPERTIES;
  data: any | UpdatePropertiesForm;
}

export type FromCreationType = FormCreationAction;
